export default __webpack_public_path__ + "static/media/Page18.0538f8f3.txt";